/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment, PureComponent } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';

import axios from 'axios';
import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
import { isMobile } from 'react-device-detect';
import ChatBot from '../pages/ChatBot';
import moment from 'moment';
import Iframe from 'react-iframe';

class Footer extends PureComponent {
  state = {};
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    this._getNotice();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  // UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
  //   return false;
  // };
  // componentWillReceiveProps = (nextProps) => {};
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    ////console.log(this.props.location.pathname)
    ////console.log(nextProps.location)
    return this.props !== nextProps;
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    //console.log(this.props.match.params.store)
    //console.log(nextProps.match.params.store)
    if (this.props !== nextProps) {
      //alert(2)
    }
  };

  _getNotice = async () => {
    const result = await this._getNoticeApi();
    const intReturn = result.data[0].intReturn;
    const notice = result.data[0].listData;

    if (intReturn === 0) {
      if (this._isMounted) {
        this.setState({
          notice,
        });
      }
    }
  };
  _getNoticeApi = () => {
    const { apiUrl } = this.props;

    return axios(apiUrl + '/footerNotice')
      .then((response) => response)
      .catch((error) => {
        //console.log(error)
      });
  };
  _onChannelInfo = () => {
    const { setChannelShow } = this.props;
    setChannelShow(true);
  };
  _goNotice = () => {
    const { history } = this.props;
    history.push('/customer/1');
  };
  _goNoticeItem = (idx) => {
    const { history } = this.props;
    history.push('/customer/1?idx=' + idx);
  };
  _aniplus = () => {
    toast.warn('준비중입니다.');
  };
  _onCompany = () => {
    window.open('https://company.aniplustv.com');
  };
  _yak = () => {
    const { history } = this.props;
    history.push('/customer/4');
  };
  _yak1 = () => {
    const { history } = this.props;
    history.push('/customer/5');
  };

  _facebook = () => {
    window.open('https://www.instagram.com/aniplusasia/', '', '');
  };
  _twetter = () => {
    window.open('https://twitter.com/ANIPLUSTV', '', '');
  };
  _youtube = () => {
    window.open('https://www.youtube.com/user/ANIPLUSINC', '', '');
  };
  _contact = () => {
    window.open('https://kor.aniplustv.com/contact', '', '');
  };
  _event = () => {
    //const { setEventIdx } = this.props;
    //setEventIdx(287)
  };
  _setChatbot = () => {
    const { chatbot, setChatbot } = this.props;
    setChatbot(!chatbot);
  };
  _naverReserve = (code) => {
    if (code === 1) {
      //최애의 아이
      window.open(
        'https://booking.naver.com/booking/12/bizes/445544/items/6175448?preview=1&tab=book',
        '',
        ''
      );
    } else {
      //홀로라이브
      window.open(
        'https://booking.naver.com/booking/12/bizes/445544/items/6175432?preview=1&tab=book',
        '',
        ''
      );
    }
  };
  render() {
    const { notice } = this.state;
    const { history, serviceEndDate } = this.props;
    return (
      <Fragment>
        {/* <div className="chatbot-icon" onClick={this._setChatbot}>
          <img src="/img/free-icon-chatbot.png" />
        </div> */}
        {moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
        serviceEndDate ? null : (
          <ChatBot />
        )}

        {/*팝업 스토어 네이버 예약 링크*/}
        {/* {history.location.pathname === '/ticket' ? null : (
          <div
            style={{
              display: 'flex',
              position: 'fixed',
              right: isMobile ? 100 : 180,
              bottom: isMobile ? 60 : 30,
              background: 'transparent',
              zIndex: 999,
              marginLeft: isMobile ? 10 : 0,
            }}
          >
            <div
              onClick={() => this._naverReserve(1)}
              style={{ cursor: 'pointer', marginRight: 10 }}
            >
              <img src="/img/popup_0924_1.png" />
            </div>
            <div
              onClick={() => this._naverReserve(2)}
              style={{ cursor: 'pointer' }}
            >
              <img src="/img/popup_0924_2.png" />
            </div>
          </div>
        )} */}

        {/*팝업 스토어 네이버 예약 링크*/}
        {/* <div
          style={{
            marginTop: 100,
            position: 'absolute',
            right: 100,
            top: 0,
            background: 'transparent',
          }}
        >
          <Iframe
            url="http://son.aniplustv.com:3002/chatbot"
            width="520px"
            height="800px"
            frameBorder={0}
            scrolling="no"
            allowtransparency="true"
            styles={{ backgroundColor: 'transparent' }}
          />
        </div> */}
        <div className="footer">
          {notice ? (
            <div className="notice_group">
              <h1 onClick={this._goNotice}>공지사항</h1>
              <ul>
                <li>
                  <span className="tag">{notice[0].categoryName}</span>
                  <a
                    style={{ cursor: 'pointer' }}
                    onClick={() => this._goNoticeItem(notice[0].idx)}
                  >
                    {notice[0].title}{' '}
                  </a>
                </li>
              </ul>
              <div className="sns_group">
                <span style={{ cursor: 'pointer' }} onClick={this._facebook}>
                  페이스북
                </span>
                <span style={{ cursor: 'pointer' }} onClick={this._twetter}>
                  트위터
                </span>
                <span style={{ cursor: 'pointer' }} onClick={this._youtube}>
                  유투브
                </span>
              </div>
            </div>
          ) : null}

          {isMobile ? (
            <div className="foot_add">
              <dl>
                <dt>
                  <h1>
                    <img
                      src={
                        history.location.pathname.indexOf('/store') > -1 ||
                        history.location.pathname.indexOf('/story') > -1
                          ? '/img/theme_light/foot_logo.png'
                          : '/img/foot_logo.png'
                      }
                    />
                  </h1>
                  <a style={{ cursor: 'pointer' }} onClick={this._onCompany}>
                    회사 소개
                  </a>
                  ㅣ
                  <a
                    style={{ cursor: 'pointer' }}
                    onClick={this._onChannelInfo}
                  >
                    지역별 채널안내
                  </a>
                  ㅣ
                  <a style={{ cursor: 'pointer' }} onClick={this._yak}>
                    이용약관
                  </a>
                  <br />
                  <a style={{ cursor: 'pointer' }} onClick={this._yak1}>
                    개인정보처리방침
                  </a>
                  <a style={{ cursor: 'pointer' }} onClick={this._green}>
                    청소년보호정책
                  </a>
                  <a style={{ cursor: 'pointer' }} onClick={this._contact}>
                    광고/제휴안내
                  </a>
                </dt>
                <dd style={{ paddingTop: 15 }}>
                  상호 : 주식회사 애니플러스{' '}
                  <em>
                    <br />
                  </em>{' '}
                  대표이사 : 전승택<em>ㅣ</em>
                  <em>ㅣ</em> 개인정보관리책임자 : 손혜환{' '}
                  <em>
                    <br />
                  </em>{' '}
                  주소 : 서울 영등포구 국제금융로 10 Three IFC 28층
                  <br />
                  사업자등록번호 : 318-81-09181{' '}
                  <em>
                    <br />
                  </em>{' '}
                  통신판매업신고번호 : 제 2020-서울영등포-2089 호 <em>ㅣ</em>{' '}
                  webmaster@aniplustv.com <br />
                  Copyright (c) 2020 ANIPLUS INC. All rights reserved
                  <br />
                </dd>
              </dl>
              <div
                className={
                  history.location.pathname.indexOf('/store') > -1 ||
                  history.location.pathname.indexOf('/story') > -1
                    ? 'foot_customer'
                    : 'foot_add_right'
                }
              >
                <h2>T. 070-7162-7013</h2>
                <p>
                  월 - 금 : 10:00AM ~ 6:00PM
                  <br />
                  토,일 공휴일 휴무 / 점심시간 : 12:30PM ~ 1:30PM
                </p>
                <div className="family_site">
                  <select name="" className="select_input foot_select">
                    <option>FAMILY SITE</option>
                  </select>
                </div>
              </div>
            </div>
          ) : (
            <div className="foot_add">
              <dl>
                <dt>
                  <h1>
                    <img
                      src={
                        history.location.pathname.indexOf('/store') > -1 ||
                        history.location.pathname.indexOf('/story') > -1
                          ? '/img/theme_light/foot_logo.png'
                          : '/img/foot_logo.png'
                      }
                    />
                  </h1>
                  <a style={{ cursor: 'pointer' }} onClick={this._onCompany}>
                    회사 소개
                  </a>
                  ㅣ
                  <a
                    style={{ cursor: 'pointer' }}
                    onClick={this._onChannelInfo}
                  >
                    지역별 채널안내
                  </a>
                  ㅣ
                  <a style={{ cursor: 'pointer' }} onClick={this._yak}>
                    이용약관
                  </a>
                  ㅣ
                  <a style={{ cursor: 'pointer' }} onClick={this._yak1}>
                    개인정보처리방침
                  </a>
                  |
                  <a style={{ cursor: 'pointer' }} onClick={this._contact}>
                    광고/제휴안내
                  </a>
                </dt>
                <dd>
                  상호 : 주식회사 애니플러스 <em>ㅣ</em> 대표이사 : 전승택{' '}
                  <em>ㅣ</em> 개인정보관리책임자 : 손혜환 <em>ㅣ</em> 주소 :
                  서울 영등포구 국제금융로 10 Three IFC 28층
                  <br />
                  사업자등록번호 : 318-81-09181 <em>ㅣ</em> 통신판매업신고번호 :
                  제 2020-서울영등포-2089 호 <em>ㅣ</em> webmaster@aniplustv.com{' '}
                  <br />
                  Copyright (c) 2020 ANIPLUS INC. All rights reserved
                  <br />
                </dd>
              </dl>
              <div
                className={
                  history.location.pathname.indexOf('/store') > -1 ||
                  history.location.pathname.indexOf('/story') > -1
                    ? 'foot_customer'
                    : 'foot_add_right'
                }
              >
                <h2 onClick={this._setChatbot}>T. 070-7162-7013</h2>
                <p>
                  월 - 금 : 10:00AM ~ 6:00PM
                  <br />
                  토,일 공휴일 휴무 / 점심시간 : 12:30PM ~ 1:30PM
                </p>
                <div className="family_site">
                  <select name="" className="select_input foot_select">
                    <option>FAMILY SITE</option>
                  </select>
                </div>
              </div>
            </div>
          )}
        </div>

        {/*
                <div className="footer">
                    { notice ? (
                        <div className="notice_group">
                            <h1>공지사항</h1>
                            <ul>
                                <li><a style={{cursor: 'pointer'}} onClick={this._goNotice}>{notice[0].categoryName}</a></li>
                                <li><a style={{cursor: 'pointer'}} onClick={this._goNotice}>{notice[0].title}</a></li>
                            </ul>
                            <div className="sns_group">
                                <span style={{cursor: 'pointer'}} onClick={this._facebook}>페이스북</span>
                                <span style={{cursor: 'pointer'}} onClick={this._twetter}>트위터</span>
                                <span style={{cursor: 'pointer'}} onClick={this._youtube}>유투브</span>
                            </div>
                        </div>
                    ) : null }
                    

                    <div className="foot_add">
                        <h1><img src="/img/theme_light/foot_logo.png"/></h1>
                        <dl>
                            <dt><a style={{cursor: 'pointer'}} onClick={this._onCompany}>회사 소개</a>ㅣ<a style={{ cursor: 'pointer'}} onClick={this._onChannelInfo}>지역별 채널안내</a>ㅣ<a style={{cursor: 'pointer'}} onClick={this._yak}>정책 및 약관</a>ㅣ<a style={{cursor: 'pointer'}} onClick={this._contact}>광고/제휴안내</a></dt>
                            <dd>
                                상호 : 주식회사 애니플러스   <em onClick={this._event}>ㅣ</em>    대표이사 : 전승택    <em>ㅣ</em>    개인정보관리책임자 : 손혜환    <em>ㅣ</em>    주소 : 서울특별시 영등포구 국제금융로 10, 28층(여의도동, Three IFC)<br/>
                                사업자등록번호 : 318-81-09181    <em>ㅣ</em>    통신판매업신고번호 : 제 2020-서울영등포-2089 호 <em>ㅣ</em> webmaster@aniplustv.com <br/>
                                Copyright (c) 2020 ANIPLUS INC. All rights reserved<br/>
                            </dd>
                        </dl>
                        <div className="foot_add_right">
                            <h2>T. 070-7162-7013</h2>
                            <p>월 - 금 : 10:00AM ~ 6:00PM<br/>토,일 공휴일 휴무 / 점심시간 : 12:30PM ~ 1:30PM</p>
                            <div className="family_site">
                                <select name="" className="select_input foot_select">
                               
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Footer));
